import React from "react";
import ViewController from "../commons/base/view_controller";
import Scaffold from "../commons/scaffold/scaffold";
import SizedDiv from "../commons/ui/sized_div";
import SoldOutMenuDashboardState from "./models/sold_out_menu_dashboard_state";
import SoldOutMenuDashboardViewModel from "./view_models/sold_out_menu_dashboard_view_model";
import SoldOutDashboardTableWidget from "./widgets/sold_out_main_course_table_widget";

export default class SoldOutMenuDashboardScreen extends ViewController<
    {},
    SoldOutMenuDashboardState,
    SoldOutMenuDashboardViewModel
> {
    interval?: NodeJS.Timer;

    constructor(props: {}) {
        super(props, new SoldOutMenuDashboardViewModel());
    }

    componentDidMount(): void {
        if (!this.interval) {
            this.interval = setInterval(() => this.viewModel.loadData(), 10000);
        }
    }

    render(): React.ReactNode {
        const vm = this.vmState;
        return (
            <Scaffold
                isShowLoading={
                    vm.majorMenuPerOutlet.size === 0 &&
                    vm.minorMenuPerOutlet.size === 0
                }
                showErrorView={
                    vm.errorMessage
                        ? { message: vm.errorMessage, action: () => {} }
                        : undefined
                }
            >
                <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-7 relative">
                    <SizedDiv height={16.0} />

                    <SoldOutDashboardTableWidget
                        title="Major"
                        soldOutMap={vm.majorMenuPerOutlet}
                    />

                    <SizedDiv height={16.0} />

                    <SoldOutDashboardTableWidget
                        title="Minor"
                        soldOutMap={vm.minorMenuPerOutlet}
                    />
                </div>
            </Scaffold>
        );
    }
}